import { ChainType } from '@lifi/sdk'

export const getWalletIcon = (id: string): string | undefined => {
  switch (id) {
    case 'walletConnect':
      return 'https://lifinance.github.io/types/src/assets/icons/wallets/walletConnect.svg'
    case 'coinbaseWalletSDK':
      return 'https://lifinance.github.io/types/src/assets/icons/wallets/coinbase.svg'
    case 'safe':
      return 'https://lifinance.github.io/types/src/assets/icons/wallets/safe.svg'
    case 'metaMaskSDK':
    case 'io.metamask':
    case 'io.metamask.bitcoin':
      return 'https://lifinance.github.io/types/src/assets/icons/wallets/metamask.svg'
    case 'baseAccount':
      return 'https://lifinance.github.io/types/src/assets/icons/wallets/baseAccount.svg'
    default:
      break
  }
}

export const getChainTypeIcon = (chainType: ChainType): string | undefined => {
  switch (chainType) {
    case ChainType.EVM:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/ethereum.svg'
    case ChainType.SVM:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/solana.svg'
    case ChainType.UTXO:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/bitcoin.svg'
    case ChainType.MVM:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/sui.svg'
    case ChainType.TVM:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/tron.svg'
    case ChainType.STL:
      return 'https://lifinance.github.io/types/src/assets/icons/chains/stellar.svg'
  }
}

export const lifiLogoUrl =
  'https://lifinance.github.io/types/src/assets/icons/bridges/lifi.svg'
